import { isEmpty } from 'ui-seeker/utils'
import { USER_ROLE } from 'app/@common/constants'
import { useAppScrollListener, useSetHotel } from 'app/@hooks';
import { useContextSelector } from 'use-context-selector'
import { AppDatesContext, AppMainHotelsContext } from 'app/providers'
import { getAppUserData } from 'app/@utils'


export default function useAppMainHotelSelector(feature) {

    const scroll = useAppScrollListener()
    const updateMainHotels = useContextSelector(AppMainHotelsContext, ({updateState}) => updateState)
    const mainHotels = useContextSelector(AppMainHotelsContext, ({state}) => state.mainHotels)
    const { role, mainHotelsSectionData, uidSlave, userId, selectedMainHotel } = getAppUserData()
    const isUserMaster = role === USER_ROLE.MASTER
    const userInfoData = mainHotelsSectionData ? mainHotelsSectionData[isUserMaster ? parseInt(uidSlave) : userId] : null
    const idMainHotel = userInfoData && !isEmpty(userInfoData[feature]) ? userInfoData[feature]?.idHotel[0] : null
    const numMonths = useContextSelector(AppDatesContext, ({state}) => state.numMonths)
    const isMultiHotel = userInfoData ? userInfoData[feature]?.isMulti : null
    const { setHotel } = useSetHotel()

    const onChange = idHotel => {
        if (idHotel === null) {
            if (selectedMainHotel) {
                localStorage.setItem('packagesLastMainHotel', selectedMainHotel)
            }
            localStorage.setItem('packagesAllHotelsMode', 'true')
            updateMainHotels({ mainHotels: null, forceRemount: Date.now() })
            return
        }
        const wasAllMode = localStorage.getItem('packagesAllHotelsMode') === 'true'
        localStorage.removeItem('packagesAllHotelsMode')
        updateMainHotels({ mainHotels: idHotel })
        if(idHotel?.toString() !== selectedMainHotel || wasAllMode) {
            setHotel(idHotel, { remount: true }).catch(e => console.error('ERROR', e))
        }
    }

    const onInit = idHotel => {
        updateMainHotels({ mainHotels: idHotel })
        if (idHotel && idHotel?.toString() !== selectedMainHotel) {
            setHotel(idHotel).catch(e => console.error('ERROR', e))
        }
    }

    return {
        scroll: scroll.y,
        onChange, onInit, setHotel, updateMainHotels, mainHotels, idMainHotel, selectedMainHotel, isUserMaster, numMonths, isMultiHotel
    }
}